import type { Company } from "@domain/company";
import type { User } from "@domain/user";
import { sortCompanies } from "@domain/job";

export interface CompaniesUseCaseDeps {
	getCompaniesByUser(user: User): Promise<Company[]>;
}

/**
 * Use cases that operate on companies.
 *
 * Currently a single `loadForUser` query: fetch every Company the user has
 * access to, sorted in display order. No React, no router — callable from a
 * CLI or any non-React caller.
 */
export class CompaniesUseCase {
	constructor(private readonly deps: CompaniesUseCaseDeps) {}

	async loadForUser(user: User): Promise<Company[]> {
		const fetched = await this.deps.getCompaniesByUser(user);
		return sortCompanies(fetched);
	}
}
